/*@ngInject*/
const QuoteActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getQuotesWithEnabledAction = function (quoteId, action) {
        const url = '/rest/Quote/' + quoteId + '/QuotesWithEnabledAction',
            config = {
                params: {
                    transition: action
                }
            };
        return this.get(url, config);
    };

    this.addSection = function (quoteId, sectionTemplateId, type) {
        const url = '/rest/Quote/' + quoteId + '/addSection',
            config = {
                params: {
                    sectionTemplateIds: sectionTemplateId,
                    sectionType: type
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        return this.post(url, {}, config);
    };

    this.beginBinding = function (quoteId) {
        const url = '/rest/Quote/' + quoteId + '/BeginBinding';

        return this.post(url);
    };

    this.bind = function (proposalId) {
        const url = '/rest/Proposal/' + proposalId + '/bind';

        return this.post(url);
    };

    this.copyQuote = function (quoteId, proposalId) {
        const url = '/rest/Quote/' + quoteId + '/copy',
            config = {
                params: {
                    proposalId: proposalId
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };

    this.declineToBind = function (quoteId, reason, details) {
        const url = '/rest/Quote/' + quoteId + '/Decline',
            config = {
                params: {
                    reason: reason,
                    detail: details
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };

    this.deleteQuote = function (quoteId) {
        const url = '/rest/Quote/' + quoteId + '/Delete';

        return this.delete(url);
    };

    this.deleteSection = function (sectionId, invalidateProposalDocument) {
        const url = '/rest/ProposalSection/' + sectionId + '/deleteSection',
            config = {
                params: {
                    invalidateProposalDocument: invalidateProposalDocument
                }
            };

        return this.delete(url, config);
    };

    this.generateBinder = function (quoteIds) {
        const url = '/rest/Proposal/generateBinder',
            config = {
                params: {
                    quoteId: quoteIds
                }
            };

        return this.post(url, {}, config);
    };

    this.generateQuote = function (quoteId) {
        var url = '/rest/Quote/' + quoteId + '/GenerateQuote';

        return this.post(url);
    };

    this.generateRatingAttachments = function (quoteId, attachmentsToGenerate) {
        const url = '/rest/Quote/' + quoteId + '/generateRatingAttachments',
            config = {
                params: {
                    attachmentsToGenerate: attachmentsToGenerate
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };

    this.getQuote = function (quoteId) {
        const url = '/rest/Quote/' + quoteId;

        return this.get(url);
    };

    this.generateRating = function (quoteIds) {
        const url = '/rest/Quote/RateQuotes',
            config = {
                params: {
                    quoteIds: quoteIds
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };

    this.modifyBinder = function (quoteId) {
        const url = '/rest/Quote/' + quoteId + '/ModifyBinder';
        return this.post(url);
    };

    this.modifyPricing = function (quoteId) {
        const url = '/rest/Quote/' + quoteId + '/ModifyPricing';

        return this.post(url);
    };

    this.modifyQuote = function (quoteId) {
        const url = '/rest/Quote/' + quoteId + '/ModifyQuote';

        return this.post(url);
    };

    this.modifyRating = function (quoteId) {
        const url = '/rest/Quote/' + quoteId + '/modifyRating';

        return this.post(url);
    };

    this.refreshQuoteByIds = function (quoteIds) {
        const url = '/rest/Quote/RefreshQuoteByIds',
            config = {
                params: {
                    quoteIds: quoteIds
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        return this.post(url, {}, config);
    };

    this.requestBinding = function (quoteId) {
        const url = '/rest/Quote/' + quoteId + '/RequestBinding';

        return this.post(url);
    };

    this.startPricing = function (quoteIds) {
        const url = '/rest/Quote/PriceQuotes',
            config = {
                params: {
                    quoteIds: quoteIds
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };

    this.startQuote = function (quoteIds) {
        const url = '/rest/Quote/StartQuotes',
            config = {
                params: {
                    quoteIds: quoteIds
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };

    this.unbind = function (quoteId, reason, detail) {
        const url = '/rest/Quote/' + quoteId + '/unbind',
            config = {
                params: {
                    reason: reason,
                    detail: detail
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };


    this.uploadSectionFromFile = function (proposalId, data, file) {
        const url = '/rest/Quote/' + proposalId + '/uploadSectionFromFile',
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                // When you assign undefined, the content type defaults to multipart/form-data
                headers: {
                    'Content-Type': undefined
                },
                params: {
                    displayLabel: data.description,
                    filename: data.name,
                    length: data.fileExpectedSize
                }
            };

        formData.append('file', file);

        return this.post(url, formData, config);
    };

    this.addSectionFromDocument = function (quoteId, attachmentId, displayLabel, sectionType) {
        const url = '/rest/Quote/' + quoteId + '/addSectionFromDocument',
            config = {
                params: {
                    attachmentId: attachmentId,
                    displayLabel: displayLabel
                }
            };

        if (sectionType) {
            config.params.sectionType = sectionType;
        }
        return this.post(url, {}, config);
    };


    this.revertToSent = function (quoteId) {
        const url = '/rest/Quote/' + quoteId + '/revertToSent';

        return this.post(url);
    };

    this.withdrawQuote = function (quoteId, reason, detail) {
        const url = '/rest/Quote/' + quoteId + '/withdraw',
            config = {
                params: {
                    reason: reason,
                    detail: detail,
                    notification: null
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };

    this.withdrawRequest = function (quoteId) {
        const url = '/rest/Quote/' + quoteId + '/withdrawRequest';

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('quoteActionRepository', QuoteActionRepository);
